__turbopack_context__.v({
  "bottomBarContainer": "BloodVisionBottomBar-module__p9w8DW__bottomBarContainer",
  "bottomBarSlideUp": "BloodVisionBottomBar-module__p9w8DW__bottomBarSlideUp",
  "buttonWrapper": "BloodVisionBottomBar-module__p9w8DW__buttonWrapper",
  "currentPrice": "BloodVisionBottomBar-module__p9w8DW__currentPrice",
  "element": "BloodVisionBottomBar-module__p9w8DW__element",
  "price": "BloodVisionBottomBar-module__p9w8DW__price",
  "priceContainer": "BloodVisionBottomBar-module__p9w8DW__priceContainer",
  "secondary": "BloodVisionBottomBar-module__p9w8DW__secondary",
  "subtitleTextBtn": "BloodVisionBottomBar-module__p9w8DW__subtitleTextBtn",
  "totalPriceSingle": "BloodVisionBottomBar-module__p9w8DW__totalPriceSingle",
});
